import React, { useEffect } from 'react'
import { TextInput, FormFieldGroup } from '@instructure/ui'
import EditLtiProvider from './EditLtiProvider'




const EditLtiRegistration = ({ name, disabled, value, onChange }) => {
  useEffect(() => {
    onChange({
      ...value,
      authorizationGrantType: 'implicit',
      redirectUri: '{baseUrl}/lti/login',
      scopes: ['openid']
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onChange])

  return <FormFieldGroup description={name} disabled={disabled} rowSpacing='small' layout='inline' vAlign='top'
  >
    <TextInput renderLabel='Registration ID'
               value={value.registrationId}
               onChange={(_, registrationId) => onChange({ ...value, registrationId })} />
    <TextInput renderLabel='Client Name'
               value={value.clientName} onChange={(_, clientName) => onChange({ ...value, clientName })} />
    <TextInput renderLabel='Client ID'
               value={value.clientId} onChange={(_, clientId) => onChange({ ...value, clientId })} />
    <EditLtiProvider value={value.providerDetails} onChange={providerDetails => onChange({
      ...value,
      providerDetails: { ...providerDetails }
    })
    } />
  </FormFieldGroup>
}

export default EditLtiRegistration
